import { isNil } from 'ramda';
import request, { type RequestOptions } from '@/utils/request';

export class HttpClient {
  public readonly urlPrefix: string;

  constructor(urlPrefix: string) {
    this.urlPrefix = urlPrefix;
  }

  async get<T>(url: string, options: RequestOptions = { signal: undefined }): Promise<T | null> {
    return await request<T>(`${this.urlPrefix}/${url}`, {
      method: 'GET',
      ...options,
    });
  }

  async post<T>(url: string, body: unknown, options: RequestOptions = { signal: undefined }): Promise<T | null> {
    return await request<T>(`${this.urlPrefix}/${url}`, {
      method: 'POST',
      body: JSON.stringify(body),
      ...options,
    });
  }

  async put<T>(url: string, body: unknown, options: RequestOptions = { signal: undefined }): Promise<T | null> {
    return await request<T>(`${this.urlPrefix}/${url}`, {
      method: 'PUT',
      body: JSON.stringify(body),
      ...options,
    });
  }

  async patch<T>(url: string, body: unknown, options: RequestOptions = { signal: undefined }): Promise<T | null> {
    return await request<T>(`${this.urlPrefix}/${url}`, {
      method: 'PATCH',
      body: JSON.stringify(body),
      ...options,
    });
  }

  async delete<T>(url: string, body?: unknown, options: RequestOptions = { signal: undefined }): Promise<T | null> {
    return await request<T>(`${this.urlPrefix}/${url}`, {
      method: 'DELETE',
      ...(!isNil(body) && { body: JSON.stringify(body) }),
      ...options,
    });
  }
}
